// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dfdb0d71","396":"3d1440b0","447":"28d8eaae","453":"d855a71b","455":"ee4672db","967":"384151ee","977":"b5623f9a"}[chunkId] + ".chunk.js";
};